import { Button, Form, Modal } from "react-bootstrap"

interface TelefonoWhatsappModalProps {
  show: boolean
  nombre: string
  telefono: string
  onTelefonoChange: (telefono: string) => void
  onCancel: () => void
  onConfirm: () => void
  isSaving?: boolean
}

const TelefonoWhatsappModal: React.FC<TelefonoWhatsappModalProps> = ({
  show,
  nombre,
  telefono,
  onTelefonoChange,
  onCancel,
  onConfirm,
  isSaving = false,
}) => (
  <Modal show={show} onHide={onCancel} centered>
    <Modal.Header closeButton>
      <Modal.Title>Cargar telefono</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-3">
        {nombre
          ? `${nombre} no tiene telefono cargado.`
          : "No hay telefono cargado."}
      </p>
      <Form.Group controlId="telefonoWhatsapp">
        <Form.Label>Telefono para WhatsApp</Form.Label>
        <Form.Control
          type="text"
          placeholder="Ej: 2634123456"
          value={telefono}
          onChange={(event) => onTelefonoChange(event.target.value)}
          autoFocus
        />
      </Form.Group>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="secondary" onClick={onCancel} disabled={isSaving}>
        Cancelar
      </Button>
      <Button
        variant="success"
        onClick={onConfirm}
        disabled={isSaving || telefono.trim() === ""}
      >
        Guardar y abrir WhatsApp
      </Button>
    </Modal.Footer>
  </Modal>
)

export default TelefonoWhatsappModal
